<!--
 * @Author: v_hllhe
 * @Date: 2022-12-13 16:58:57
 * @LastEditors: v_aydwang
 * @LastEditTime: 2023-01-05 16:32:30
 * @Description:
-->
<template>
  <div>
    <div id="bigScrenn" v-waterMark="{text: nickname, width:300, height:200}">
      <conduit ref="conduit" class="conduitBox"></conduit>
      <div class="ice">
        <head-top class="head"></head-top>
        <basic-information
          class="basic"
          @cardAssembly="cardAssembly"
        ></basic-information>
        <card-assembly
          ref="cardAssembly"
          class="card"
          :cardData="cardData"
          :searchParams="searchParams"
        ></card-assembly>
        <center-score class="score" :scoreInfo="qualityRate"></center-score>
        <bottom-score
          ref="bottomScore"
          class="bottomScore"
          @skillOpen="skillOpen"
        ></bottom-score>
        <personalDetails
          :detailVisible="skillVisible"
          :workDetailsList="workDetailsList"
          :messageList="messageList"
        >
          <template v-slot:close>
            <div @click="closeModal" class="close-x"></div>
          </template>
        </personalDetails>
      </div>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import conduit from './modules/conduit.vue';
import headTop from './modules/headTop.vue';
import basicInformation from './modules/basicInformation.vue';
import cardAssembly from './modules/cardAssembly.vue';
import centerScore from './personnel-general/centerScore.vue';
import bottomScore from './personnel-general/bottomScore.vue';
import personalDetails from './modules/personalDetails.vue';
import {
  getScore,
  getHistoryWork,
  getHistoryProject,
} from '@/api/personnelLarge.js';
import { mapState } from 'vuex';

export default {
  name: '',
  // import引入的组件需要注入到对象中才能使用
  components: {
    conduit,
    headTop,
    basicInformation,
    cardAssembly,
    centerScore,
    bottomScore,
    personalDetails,
    // largeBottom,
  },
  data() {
    // 这里存放数据
    return {
      cardData: {},
      searchParams: {},
      qualityRate: {},
      skillVisible: false,
      workDetailsList: [], // 作业情况
      messageList: [], // 历史项目信息
    };
  },
  // 监听属性 类似于data概念
  computed: {
    ...mapState({
      nickname: state => state.user.name,
    }),
  },
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    cardAssembly(params) {
      this.init(params);
    },
    init(params) {
      this.qualityRate = {};
      this.cardData = {};
      if (params.production_line_code) {
        getScore({ ...params }).then((res) => {
          this.qualityRate = { ...res };
          this.cardData = {
            ...res,
            zl: res.zl != 0 ? Number((res.zl * 100).toFixed(2)) : 0,
            zl_standard: res.zl_standard * 100,
          };
        });
      }
      this.searchParams = { ...params };
      if (params.code) {
        this.$refs.bottomScore.init(this.searchParams.uid);
        getHistoryWork({ uid: params.uid }).then((res) => {
          if (res) {
            this.workDetailsList = [...res];
          }
        });
        getHistoryProject({ uid: params.uid }).then((res) => {
          if (res) {
            this.messageList = [...res];
          }
        });
      }
    },
    skillOpen(visible) {
      this.skillVisible = visible;
    },
    closeModal() {
      this.skillVisible = false;
    },
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss" scoped>
@import "@/styles/convert-viewport";
#bigScrenn {
  width: 100%;
  height: 100vh;
  background: url("~@/assets/personnel-large/bgColor.png") no-repeat;
  background-size: 100% 100%;
  position: relative;
  overflow: hidden;
  .ice {
    height: 100%;
    background: url("~@/assets/personnel-large/iceberg.png") no-repeat;
    background-size: 100% 100%;
  }
  .card {
    position: absolute;
    top: vh(230);
  }
  .conduitBox {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 0;
    width: vw(1920);
    height: vh(1080);
  }
  .score {
    position: absolute;
    // z-index: 1;
    top: vh(310);
    left: 50%;
    transform: translateX(-50%);
  }
  .bottomScore {
    position: absolute;
    left: 50%;
    bottom: vh(18);
    transform: translateX(-50%);
  }
}
.close-x {
  width: vw(32);
  height: vw(32);
  background: url("~@/assets/personnel-large/close.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: vh(8);
  right: vw(10);
  cursor: pointer;
}
</style>

